/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free, full-screen online countdown timer with an alarm. Set any time, start, pause and reset — plus one-click preset timers and a stopwatch. No signup.`)
};

const es_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de cuenta regresiva online gratis con alarma, a pantalla completa. Inicia, pausa y reinicia — con presets y cronómetro. Sin registro.`)
};

const de_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein kostenloser Online-Countdown-Timer mit Alarm. Zeit einstellen, starten, pausieren, zurücksetzen — plus Timer mit Voreinstellungen und Stoppuhr. Keine Anmeldung nötig.`)
};

const nl_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gratis online afteltimer met alarm. Stel elke tijd in, start, pauzeer en reset — plus eenklikstimers en een stopwatch. Geen aanmelding nodig.`)
};

const fr_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur compte à rebours en ligne gratuit et plein écran, avec alarme. Démarrez, mettez en pause, réinitialisez — plus des minuteurs prédéfinis et un chronomètre. Sans inscription.`)
};

const it_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer countdown online gratuito a schermo intero con allarme. Imposta la durata, avvia e ripristina — timer preimpostati e cronometro. Nessuna registrazione.`)
};

const pt_br2_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador online grátis, em tela cheia, com alarme. Inicie, pause e redefina — inclui temporizadores predefinidos e cronômetro. Sem cadastro.`)
};

const pt_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de contagem decrescente online, gratuito e em ecrã inteiro, com alarme. Inicie, pause e reponha — mais temporizadores predefinidos e um cronómetro. Sem registo.`)
};

const ja_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アラーム付きの無料オンラインカウントダウンタイマーを全画面で。任意の時間を設定してスタート、一時停止、リセット。ワンクリックのプリセットタイマーとストップウォッチも。登録不要。`)
};

const zh_timer_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费全屏在线倒计时器，带闹铃提醒。设置任意时长，开始、暂停、重置 — 还有一键预设计时器和秒表。无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_meta_description", locale)
	if (locale === "en") return en_timer_hub_meta_description(inputs)
	if (locale === "es") return es_timer_hub_meta_description(inputs)
	if (locale === "de") return de_timer_hub_meta_description(inputs)
	if (locale === "nl") return nl_timer_hub_meta_description(inputs)
	if (locale === "fr") return fr_timer_hub_meta_description(inputs)
	if (locale === "it") return it_timer_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_meta_description(inputs)
	if (locale === "pt") return pt_timer_hub_meta_description(inputs)
	if (locale === "ja") return ja_timer_hub_meta_description(inputs)
	return zh_timer_hub_meta_description(inputs)
};